import React, { useMemo, useState, useEffect, useRef } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { ColumnTime, ColumnStatus, ColumnEvent, ColumnEventWithCompetitor, ColumnCompetitor, ColumnResult, ColumnLocation } from "components/common/schedule/TableColumns"
import { useUrlFriendlyToParameters, useNavigateTo, useGetURL } from 'helpers/urlFriendly';
import { getLevelRSC, getEventRSC } from "helpers/rsc"
import { ALL_URL, getDateTimeFormat } from "helpers/utils";
import Discipline from "components/presentation/Discipline";
import DateTime from "components/presentation/DateTime";


const getConfiguration = (breakPoint, eventorder, paramsURL, getURL, isH2H) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [];
  switch (eventorder) {
    case 'DATE':
      configuration.sortBy = [{ id: 'Time', desc: false }]
      break;
    case 'LOC':
      configuration.sortBy = [];
      configuration.disableSort = true
      break;
  }

  configuration.columns = isMobile ? TableColumnsSM(paramsURL, getURL, isH2H) : TableColumns(configuration.disableSort, paramsURL, getURL, isH2H)
  return configuration;
};




const DateScheduleTable = ({ data, eventorder, activeDiscipline, isH2H }) => {
  const { breakPoint } = useViewport();
  const [discipline, setDiscipline] = useState('')
  const [state, setState] = useState('')
  const day = data[0]?.startDate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }
  const getURL = useGetURL()
  const config = useMemo(() => getConfiguration(breakPoint, eventorder, paramsURL, getURL, isH2H), [breakPoint]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results', state)
  const accordElem = useRef(null);
  //Prepare URL to navigate
  const showDiscipline = paramsURL["mirs_discipline"] === ALL_URL.ALL_DISC;

  useEffect(() => {
    if (data?.length > 0) {
      setDiscipline(data[0]?.discipline?.code);
    } else {
      setDiscipline('')
    }
  }, [data])

  if (eventorder === 'LOC') {
    data = data.sort((a, b) => {
      const locationSort = a?.location?.locationOrder - b?.location?.locationOrder;
      const orderSort = a?.order - b?.order;
      const startTimeSort = new Date(a?.startDate) - new Date(b?.startDate);

      return locationSort || startTimeSort || orderSort;
    })
  }

  // to monitor activediscipline and scroll to it
  useEffect(() => {
    if (activeDiscipline?.current && discipline && (activeDiscipline.current === discipline)) {
      executeScroll();
    }
  }, [activeDiscipline, discipline]);

  const executeScroll = () =>
    accordElem?.current?.scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
      // block: "end",
    })

  const handleClick = (props) => {
    const resultRSC = (props?.eventUnit?.resultRSC)
    const rsc = resultRSC || props?.eventUnit?.code;

    const disciplineCode = props?.discipline?.code;

    paramsURL["mirs_event"] = getEventRSC(rsc)
    paramsURL["mirs_rsc"] = rsc
    paramsURL['mirs_discipline'] = disciplineCode;

    //Add state is sports like CLB thar results are brackets. Send position inside of bracket
    //Only brackets with bracketPase FNL     
    const el = data.find(item => item.code === props?.eventUnit?.code)
    if (el) {
      setState({ state: { bracketPosition: el?.eventUnit?.phase?.order, bracketCode: 'FNL' } });
    }
    setParamsUrl(paramsURL);
    if (rsc.indexOf('TRNO') === -1 && rsc.indexOf('TMRY') === -1 && (props?.status?.code !== "CANCELLED") && (props?.eventUnit?.type !== "NONE")) {
      setShouldNavigate(true);
    }
  };

  return (
    <Accordion className='schedule-container' defaultActiveKey="0" ref={accordElem}>
      <Accordion.Item eventKey="0">
        <Accordion.Header className='schedule-title' id={`table-${discipline}-${day}`}>
          {showDiscipline
            ? <Discipline code={data[0]?.discipline?.code} className={'img-fluid page-header-disciplina float-start w-5'} />
            : <>
              <DateTime format={getDateTimeFormat('DayName-DayNum-MonthShort')} datetime={day} />
            </>
          }
        </Accordion.Header>
        <Accordion.Body className="p-0">

          <MirsTable
            ariaLabelledby={`table-${discipline}-${day}`}
            className="table-schedule"
            data={data}
            columns={config.columns}
            keyRow='eventUnit-code'
            initialSortBy={config.sortBy}
            rowOnClick={true}
            rowClickHandler={handleClick}
            id={`mirs-table-schedule-${discipline}-${day}`}
            getRowProps={row => (
              {
                className: (row.original?.code?.indexOf('TRNO') === -1 && row.original?.code?.indexOf('TMRY') === -1 && (row.original?.status?.code !== "CANCELLED") && (row.original?.eventUnit?.type !== "NONE")) ? 'clickable-row' : ''
              }
            )}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export default DateScheduleTable;



function TableColumns(disableSort, paramsURL, getURL, isH2H) {
  return (
    [
      ColumnTime({ disableSort: disableSort }),
      ColumnEvent({ disableSort: disableSort, paramsURL, getURL }),
      ColumnCompetitor({ paramsURL, isH2H }),
      ColumnResult({}),
      ColumnStatus({}),
      ColumnLocation({ disableSort: disableSort })
    ]
  )
}

function TableColumnsSM(paramsURL, getURL, isH2H) {
  return (
    [
      ColumnTime({ disableSort: true }),
      ColumnEventWithCompetitor({ disableSort: true, paramsURL, getURL, isH2H }),
      ColumnStatus({}),
    ]
  )
}


